// Does this device prefer reduced motion? Returns `null` server-side.
export const prefersReducedMotion = { current: null };
export const hasReducedMotionListener = { current: false };
//# sourceMappingURL=state.js.map